<template>
    <AuthLayout :loading="form.processing">
        <template #logo>
            <div class="flex justify-end items-center pb-8 ">
                <AppLogo />
            </div>
        </template>
        <div>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">Welcome Back</h2>
            <p class="text-sm text-gray-600 mb-6">Login to continue shopping.</p>

            <form @submit.prevent="submit">
                <div class="mb-4">
                    <JetLabel for="email">Email</JetLabel>
                    <JetInput id="email" v-model="form.email" type="email" class="block w-full mt-1" required
                        autofocus />
                </div>

                <div class="mb-4">
                    <JetLabel for="password" value="Password" class="block" />
                    <JetInput id="password" v-model="form.password" type="password" class="block w-full mt-1" required
                        autocomplete="current-password" />
                    <div v-if="errors('email')" class="text-red-500">
                        {{ errors('email') }}
                    </div>
                </div>
                <div class="block mt-4">
                    <label class="flex items-center">
                        <JetCheckbox v-model="form.remember" name="remember" />
                        <span class="ml-2 text-sm text-black-600">Remember me</span>
                    </label>
                </div>

                <div class="flex flex-wrap items-center justify-center gap-4 mt-4 text-center">

                    <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="px-6 py-2">
                        Login
                    </JetButton>

                    <!-- Forgot Password -->
                    <!-- Wrap the link in a flex container for vertical centering -->
                    <div class="flex items-center h-10">
                        <inertia-link v-if="canResetPassword" :href="route('password.request')"
                            class="text-sm text-green-700 hover:text-green-500">
                            Forgot your password?
                        </inertia-link>
                    </div>

                    <!-- Register link -->
                    <p class="text-sm text-gray-600">
                        Don’t have an account?
                        <inertia-link :href="route('register')" class="text-green-700 hover:text-green-500 font-semibold">
                            Register
                        </inertia-link>
                    </p>
                </div>

            </form>
        </div>
    </AuthLayout>
</template>

<script>
import AuthLayout from '@/Layouts/AuthLayout.vue'
import AppLogo from '@/Components/AppLogo.vue'
import JetButton from '@/Jetstream/Button';
import JetInput from '@/Jetstream/Input';
import JetCheckbox from '@/Jetstream/Checkbox';
import JetLabel from '@/Jetstream/Label';

export default {
    components: {
        AuthLayout,
        AppLogo,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
    },

    props: {
        canResetPassword: Boolean,
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false,
            }),
        };
    },

    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    remember: this.form.remember ? 'on' : '',
                }))
                .post(this.route('login'), {
                    onFinish: () => this.form.reset('password'),
                });
        },
    },

    // created() {
    //     this.$inertia.on('start', () => {
    //         this.loading = true
    //     })

    //     this.$inertia.on('finish', () => {
    //         this.loading = false
    //     })
    // },
};
</script>

<style scoped>
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.animate-spin {
    animation: spin 1s linear infinite;
}
</style>
